import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SEO from '../SEO';

export default function NotFound() {
  return (
    <>
      <SEO 
        title="Page Not Found | BetterByAI"
        description="We couldn't find the page you're looking for."
        canonical="https://betterbyai.com/404"
      />
      
      <div className="min-h-[80vh] flex items-center justify-center">
        <div className="container px-4 sm:px-6 lg:px-8 py-24">
          <div className="max-w-3xl mx-auto text-center">
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="mb-8"
            >
              <div className="relative inline-block">
                <div className="absolute -inset-6 rounded-full bg-[#FF7066]/10 blur-xl"></div>
                <h1 className="relative text-8xl md:text-9xl font-bold text-[#FF7066]">404</h1>
              </div>
            </motion.div>
            
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="text-3xl md:text-4xl font-bold text-primary mb-6"
            >
              Page Not Found
            </motion.h2>
            
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="text-xl text-secondary mb-10"
            >
              We couldn't find the page you're looking for. It might have been moved, 
              deleted, or perhaps never existed.
            </motion.p>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="flex flex-col sm:flex-row items-center justify-center gap-4"
            >
              <Link 
                to="/" 
                className="bg-[#FF7066] text-white px-6 py-3 rounded-lg hover:bg-[#FF8A82] transition-colors font-medium"
              >
                Return to Homepage
              </Link>
              
              <Link 
                to="/services" 
                className="border-2 border-[#FF7066] text-[#FF7066] px-6 py-3 rounded-lg hover:bg-[#FF7066]/5 transition-colors font-medium"
              >
                Explore Our Services
              </Link>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.6 }}
              className="mt-16 flex flex-col items-center"
            >
              <p className="text-secondary mb-4">Need assistance?</p>
              <Link 
                to="/contact" 
                className="text-[#FF7066] font-medium hover:underline inline-flex items-center"
              >
                Contact our team
                <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                </svg>
              </Link>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
}